import React from 'react'
import {Box } from 'grommet'
import ListBillingShipments from '../../../components/listBillingShipments'
import {withRouter} from 'react-router-dom'
import { NavigationSnackBar } from '../../../components/utils/shared/shared';

function AdminAllInvoices (props) {

  return (
  <Box margin='small'>
     <NavigationSnackBar user={props.user} pages={[{name: 'Dashboard', link:'/dashboard'},{name: 'Invoices'}]}  />
     <ListBillingShipments props={props} />
   </Box>
  )
}

export default withRouter(AdminAllInvoices)
